<template>
  <div class="w-full bg-white pb-16 tab-content">
    <div
      class="header-content px-4 py-8 mb-4 border-b flex item-center justify-between"
    >
      <h2>{{ $t('message.selfService.taskManager.bank') }}</h2>
      <div class="flex justify-end items-center" v-if="shownSave">
        <zt-button
          color="dark-300"
          @click="cancel"
          class="mr-4"
          data-vs-button="cancel-bank-edit"
        >
          {{ $t('message.selfService.linkCancel') }}
        </zt-button>
        <zt-button
          @click="saveBankInfo"
          :loader="isLoading"
          data-vs-button="confirm-bank-edit"
          :disabled="isDisabled"
        >
          {{ $t('message.selfService.linkSaveChanged') }}
        </zt-button>
      </div>
    </div>
    <div class="px-4 pb-1" :key="reRenderKey">
      <vue-element-loading
        :active="isLoading"
        spinner="mini-spinner"
        color="#004250"
        style="height: 100%; width: 100%; z-index: 100"
      />
      <div v-if="shownAlert" class="mb-12">
        <zt-alert
          :color="statusAlert"
          :duration="durationAlert"
          close-icon
          filled
          @afterClosed="closeAlert"
          class="message px-3 py-3"
        >
          <div slot="custom-content">
            <div class="flex justify-start items-center">
              <zt-icon
                v-if="iconName"
                :name="iconName"
                class="icon mr-3"
              ></zt-icon>
              <p class="text-base">{{ messageAlert }}</p>
            </div>
          </div>
        </zt-alert>
      </div>
      <template v-if="$store.getters.getUser.pais === 'PE'">
        <div>
          <h2 class="payment-type-title">
            {{ $t('message.employeePanel.userAccount') }}
          </h2>
          <div class="flex">
            <div class="w-1/2 mr-4 custom-input mt-10 relative">
              <zt-input
                v-model="params.name_bank"
                name="nameBank"
                class="w-full"
                :label="$t('message.selfService.taskManager.field.nameBank')"
                data-vs-input="nameBank"
                :disabled="true"
              />
            </div>
            <div class="w-1/2 mr-4 custom-input mt-10 relative">
              <zt-input
                v-model="params.account_number"
                name="accountNumber"
                class="w-full"
                :label="
                  $t('message.selfService.taskManager.field.account_number')
                "
                data-vs-input="accountNumber"
                :disabled="true"
              />
            </div>
          </div>
          <div class="flex">
            <div class="w-1/2 mr-4 custom-input mt-10 relative">
              <zt-input
                v-model="params.cbu"
                name="cbu"
                class="w-full"
                :label="$t('message.selfService.taskManager.field.cci')"
                data-vs-input="cbu"
                :disabled="true"
              />
            </div>
            <div class="w-1/2 mr-4 custom-input mt-10 relative">
              <zt-input
                v-model="params.account_type"
                name="accountType"
                class="w-full"
                :label="
                  $t('message.selfService.taskManager.field.bankAccountType')
                "
                data-vs-input="accountType"
                :disabled="true"
              />
            </div>
          </div>
        </div>
        <div class="mt-8">
          <h2 class="payment-type-title">
            {{ $t('message.employeePanel.userAccountCTS') }}
          </h2>
          <div class="flex">
            <div class="w-1/2 mr-4 custom-input mt-10 relative">
              <zt-input
                v-model="params.name_bank_cts"
                name="nameBankCts"
                class="w-full"
                :label="$t('message.selfService.taskManager.field.nameBank')"
                data-vs-input="nameBankCts"
                :disabled="true"
              />
            </div>
            <div class="w-1/2 mr-4 custom-input mt-10 relative">
              <zt-input
                v-model="params.account_number_cts"
                name="accountNumberCts"
                class="w-full"
                :label="
                  $t('message.selfService.taskManager.field.account_number')
                "
                data-vs-input="accountNumberCts"
                :disabled="true"
              />
            </div>
          </div>
          <div class="flex">
            <div class="w-1/2 mr-4 custom-input mt-10 relative">
              <zt-input
                v-model="params.cbu_cts"
                name="cbuCts"
                class="w-full"
                :label="$t('message.selfService.taskManager.field.cci')"
                data-vs-input="cbuCts"
                :disabled="true"
              />
            </div>
            <div class="w-1/2 mr-4 custom-input mt-10 relative">
              <zt-input
                v-model="params.account_type_cts"
                name="accountTypeCts"
                class="w-full"
                :label="
                  $t('message.selfService.taskManager.field.bankAccountType')
                "
                data-vs-input="accountTypeCts"
                :disabled="true"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="flex">
          <div class="w-1/2 mr-4 custom-input mt-10 relative">
            <zt-input
              v-model="params.name_bank"
              v-validate="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 3, max: 150 }"
              name="nameBank"
              class="w-full"
              :color="errors.has('nameBank') ? 'danger' : 'primary'"
              :label="$t('message.selfService.taskManager.field.nameBank')"
              data-vs-input="nameBank"
              :disabled="readonly"
            />
            <div class="text-zt-danger" v-if="errors.has('nameBank')">
              <span>
                {{ errors.first('nameBank') }}
              </span>
            </div>
          </div>
          <div class="w-1/2 ml-4 mt-10 custom-input relative">
            <zt-input
              v-model="params.cbu"
              v-validate="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 3, max: 35 }"
              name="cbu"
              class="w-full"
              :color="errors.has('cbu') ? 'danger' : 'primary'"
              :label="$t('message.selfService.taskManager.field.cbu')"
              data-vs-input="cbu"
              :disabled="readonly"
            />
            <div class="text-zt-danger" v-if="errors.has('cbu')">
              <span>
                {{ errors.first('cbu') }}
              </span>
            </div>
          </div>
        </div>
        <div class="flex">
          <div class="w-1/2 mt-10 mr-4 custom-input relative">
            <zt-input
              v-model="params.account_type"
              v-validate="{ regex: /^[0-9a-zA-Z-À-ú-\s]+$/, min: 3, max: 20 }"
              name="typeAccount"
              class="w-full"
              :color="errors.has('typeAccount') ? 'danger' : 'primary'"
              :label="
                $t('message.selfService.taskManager.field.bankAccountType')
              "
              data-vs-input="typeAccount"
              :disabled="readonly"
            />
            <div class="text-zt-danger" v-if="errors.has('typeAccount')">
              <span>
                {{ errors.first('typeAccount') }}
              </span>
            </div>
          </div>
          <div class="w-1/2 ml-4 mt-10 custom-input relative"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { isEqual } from 'lodash'
import VueElementLoading from 'vue-element-loading'
import Employee from '@/apiClient/Employee'
import parseNull from '@/utils/parseNull'
const icons = {
  danger: 'exclamation-circle-solid',
  info: 'info-circle-solid'
}
export default {
  name: 'UserBankInfo',
  components: {
    VueElementLoading
  },
  props: {
    updateFn: {
      type: Function,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bankData: {},
      isLoading: false,
      params: {
        cbu: '',
        name_bank: '',
        account_type: ''
      },
      shownAlert: false,
      shownSave: false,
      statusAlert: 'info',
      messageAlert: '',
      cache: {},
      reRenderKey: 0,
      isEdition: false
    }
  },
  watch: {
    params: {
      handler(newParams) {
        this.shownSave = !isEqual(this.cache, newParams)
      },
      deep: true
    }
  },
  computed: {
    iconName() {
      return icons[this.statusAlert]
    },
    isDisabled() {
      return (
        this.errors.has('nameBank') ||
        this.errors.has('typeAccount') ||
        this.errors.has('cbu')
      )
    }
  },
  created() {
    this.employee = new Employee()
  },
  mounted() {
    this.getEmployeeBankInfo()
  },
  methods: {
    closeAlert() {
      this.shownAlert = false
    },
    cancel() {
      this.infoUpdate()
      this.errors.clear()
      this.shownAlert = false
      this.reRenderKey += 1
    },
    infoUpdate() {
      this.params = { ...this.bankData }
      this.cache = { ...this.bankData }
    },
    saveBankInfo() {
      this.isEdition ? this.editBank() : this.saveBank()
    },
    async editBank() {
      this.isLoading = true
      const idEmployee = this.params.id
      const payload = {
        cbu: this.params.cbu ? this.params.cbu.trim() : '',
        name_bank: this.params.name_bank ? this.params.name_bank.trim() : '',
        account_type: this.params.account_type
          ? this.params.account_type.trim()
          : ''
      }
      try {
        await this.employee.updateBankInfo(idEmployee, payload)
        this.shownSave = false
        this.bankData = payload
        this.durationAlert = 5
        this.messageAlert = this.$t(`message.selfService.statusOk`)
        this.statusAlert = 'info'
        this.shownAlert = true
        this.isLoading = false
        this.shownSave = false
      } catch (error) {
        if (error.response.data) {
          this.messageAlert = this.$t(
            `message.selfService.errors.${error.response.data.codes[0].code}`
          )
          this.statusAlert = 'danger'
          this.shownAlert = true
        }
        this.isLoading = false
      }
    },
    async saveBank() {
      this.isLoading = true
      const idEmployee = this.$route.params.id
      const payload = {
        cbu: this.params.cbu ? this.params.cbu.trim() : '',
        name_bank: this.params.name_bank ? this.params.name_bank.trim() : '',
        account_type: this.params.account_type
          ? this.params.account_type.trim()
          : ''
      }
      try {
        await this.employee.createBankInfo(idEmployee, payload)
        this.durationAlert = 5
        this.messageAlert = this.$t(`message.selfService.statusOk`)
        this.statusAlert = 'info'
        this.shownAlert = true
        this.isLoading = false
        this.shownSave = false
        this.isEdition = true
      } catch (error) {
        if (error.response.data) {
          this.messageAlert = this.$t(
            `message.selfService.errors.${error.response.data.codes[0].code}`
          )
          this.statusAlert = 'danger'
          this.shownAlert = true
        }
        this.isLoading = false
      }
    },
    async getEmployeeBankInfo() {
      const idEmployee = this.$route.params.id
      this.isLoading = true
      try {
        const {
          data: { data }
        } = await this.employee.getBankInfo(idEmployee)
        this.bankData = parseNull({ ...data })
        await this.infoUpdate()
        this.reRenderKey += 1
        this.isLoading = false
        this.isEdition = true
      } catch (error) {
        this.isLoading = false
        this.isEdition = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}

.header-content {
  h2 {
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    color: #4f41a3;
  }
}

::v-deep .zt-input-disabled .zt-input-slot .zt-label[data-v-aea3bcaa] {
  color: #969696;
}

.payment-type-title {
  color: #4f41a3;
  font-size: 18px;
  font-weight: 500;
}
</style>
